import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Upload from '../pages/Upload';
import ErrorPage from '../pages/ErrorPage';
import Login from '../pages/Login';
import ManagedRoute from './ManagedRoute';

const AppRouter = () => {
  return (
    <Router>
      <AnimatePresence exitBeforeEnter>
        <Switch>
          <ManagedRoute
            key="upload"
            exact
            path="/"
            component={Upload}
            isPrivate
          />
          <ManagedRoute key="login" path="/login" component={Login} />
          <Route key="error" component={ErrorPage} />
        </Switch>
      </AnimatePresence>
    </Router>
  );
};

export default AppRouter;
